<template>
  <spondei-embed id="sp-container-popover" displaylogo="false" displaylanguageupdate="false" attr="sp-container-popover"
    src="https://top-auto.spondei.com/s/BbClYFC5lds=" height="700" width="100%" type="popover" popoverOpened="false"
    btncolor="#1D4ED8"></spondei-embed>
</template>

<script setup lang="ts">

const contactEmbed = useContactEmbed();
const route = useRoute();
const hasLoadedScript = ref(false);
const isEmbedBlockedRoute = computed(() =>
  route.path.startsWith('/authentication') ||
  route.path.startsWith('/dashboard/parameter')
);

const loadScript = () => {
  return new Promise<boolean>((resolve) => {
    const existingScript = document.querySelector(
      'script[src="https://app.spondei.com/assets/js/embedCode.js"]'
    ) as HTMLScriptElement | null;

    if (existingScript) {
      if (existingScript.dataset.loaded === 'true') {
        hasLoadedScript.value = true;
        resolve(true);
        return;
      }

      existingScript.addEventListener('load', () => {
        existingScript.dataset.loaded = 'true';
        hasLoadedScript.value = true;
        resolve(true);
      }, { once: true });

      existingScript.addEventListener('error', () => resolve(false), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://app.spondei.com/assets/js/embedCode.js';
    script.defer = true;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = 'true';
      hasLoadedScript.value = true;
      resolve(true);
    };
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const openEmbedPopover = async () => {
  for (let i = 0; i < 6; i += 1) {
    const embedButton = document.querySelector('.btnPopover') as HTMLElement | null;
    if (embedButton) {
      embedButton.click();
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, 150));
  }
};

watch(() => contactEmbed.showEmbed, async (isOpen) => {
  if (!isOpen) return;

  // Avoid loading third-party chat embed on authentication/account-security pages.
  if (isEmbedBlockedRoute.value) {
    return;
  }

  if (!hasLoadedScript.value) {
    await loadScript();
  }

  await openEmbedPopover();
});

onMounted(async () => {
  // Ensure the floating contact button exists after refresh.
  if (isEmbedBlockedRoute.value || hasLoadedScript.value) return;
  await loadScript();
});

</script>
